import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { INoteModel } from '@apps-common/types/management/note'

export const QUERY_MANAGEMENT_GET_NOTES = (noteId?: string) => ['getNote', noteId].filter(Boolean)

export const getNote = async (noteId: string): Promise<INoteModel> =>
  axios.get(`/management/note/getnote?noteId=${noteId}`).then((res) => res.data?.data)

type QueryFnType = typeof getNote

type Props = {
  config?: QueryConfig<QueryFnType>
  noteId: string
}

export const useManagementGetNote = ({ config, noteId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_MANAGEMENT_GET_NOTES(noteId),
    queryFn: () => getNote(noteId)
  })
